import * as React from 'react';
import memoize from 'memoize-one';
import { EnvironmentContext } from './EnvironmentContext';
import { LanguageContext } from './LanguageContext';
import URLData from './URLData';
class URLDataProvider extends React.Component {
    constructor() {
        super(...arguments);
        this.getBuilder = memoize((environment, lang) => {
            return new URLData({ ...environment, lang });
        });
    }
    render() {
        const { children } = this.props;
        return (React.createElement(EnvironmentContext.Consumer, null, (environment) => React.createElement(LanguageContext.Consumer, null, ({ lang }) => children(this.getBuilder(environment, lang)))));
    }
}
export default URLDataProvider;
